var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "textual_menu--container page-content" },
    [
      _c("h1", { ref: "title" }, [
        _vm.menu
          ? _c("span", [_vm._v(_vm._s(_vm.menu.full_title) + " ")])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("menu-switcher", {
        ref: "switcher",
        attrs: {
          menus: _vm.allRelatedMenus,
          "current-menu-id": _vm.currentMenuId,
          "device-asset-code": _vm.deviceAssetCode,
          "is-dock-left": "",
        },
        on: { opened: _vm.closeSearchMenu },
      }),
      _vm._v(" "),
      _c("search-menu", {
        ref: "search",
        attrs: {
          "search-index": _vm.searchIndex,
          "search-key": _vm.searchKey,
          "search-host": _vm.searchHost,
          menu: _vm.menu,
          "minimize-widget": "",
        },
        on: {
          "view-menu-item": function ($event) {
            return _vm.scrollToMenuItem($event)
          },
          "toggle-menu-item-favorite": function ($event) {
            return _vm.$store.commit("toggleMenuItemSelected", [
              $event,
              _vm.menu?.menu_id || 0,
            ])
          },
        },
      }),
      _vm._v(" "),
      _c("a", {
        staticClass:
          "item_button--container item_button--container-cart material-icons textual_menu--glass_effect",
        class: { "item_button--container-active": _vm.showSelectedMenuItems },
        attrs: { href: "#", title: "Click to view your saved items" },
        on: {
          click: function ($event) {
            $event.preventDefault()
            _vm.showSelectedMenuItems = !_vm.showSelectedMenuItems
          },
        },
      }),
      _vm._v(" "),
      _vm.menu && _vm.menu.menu_content_area_top.length
        ? _c(
            "div",
            {
              staticClass:
                "body-container page-links no-images show-all-items textual_menu--section",
            },
            [
              _c("div", { staticClass: "page-link-group-copy" }, [
                _c("div", {
                  staticClass: "viewport",
                  domProps: {
                    innerHTML: _vm._s(_vm.menu.menu_content_area_top),
                  },
                }),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.sectionStructures, function (sectionStructure) {
        return _c("default-section", {
          key: "section-" + sectionStructure.section.ms_id,
          ref: "section--" + sectionStructure.section.ms_id,
          refInFor: true,
          attrs: {
            menu: _vm.menu,
            section: sectionStructure.section,
            items: sectionStructure.items,
          },
        })
      }),
      _vm._v(" "),
      _vm.menu && _vm.menu.menu_content_area_bottom.length
        ? _c(
            "div",
            {
              staticClass:
                "body-container page-links no-images show-all-items textual_menu--section",
            },
            [
              _c("div", { staticClass: "page-link-group-copy" }, [
                _c("div", {
                  staticClass: "viewport",
                  domProps: {
                    innerHTML: _vm._s(_vm.menu.menu_content_area_bottom),
                  },
                }),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("menu-section-list", {
        ref: "footer",
        attrs: {
          "current-section": _vm.currentSection,
          sections: _vm.menu?.sections || [],
        },
        on: {
          "update:currentSection": function ($event) {
            _vm.currentSection = $event
          },
        },
      }),
      _vm._v(" "),
      _c(
        "peppermill-dialog",
        {
          attrs: {
            title: "Saved Items",
            "label-confirm": "CLOSE",
            active: _vm.showSelectedMenuItems,
            "is-alert": "",
          },
          on: {
            close: function ($event) {
              _vm.showSelectedMenuItems = false
            },
            submit: function ($event) {
              _vm.showSelectedMenuItems = false
            },
          },
        },
        [
          _c(
            "ul",
            {
              staticClass: "favorites--container",
              attrs: { slot: "body" },
              slot: "body",
            },
            [
              _vm._l(_vm.favoriteMenuItems, function (menuItem) {
                return _c("li", { key: menuItem.mi_id }, [
                  _c("div", { staticClass: "favorites--content" }, [
                    _c("h4", [_vm._v(_vm._s(menuItem.mi_title))]),
                    _vm._v(" "),
                    _c("h5", [_vm._v(_vm._s(menuItem.mi_subtitle))]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(menuItem.mi_description))]),
                  ]),
                  _vm._v(" "),
                  _c("a", {
                    staticClass:
                      "item_button--container item_button--container-view material-icons",
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.scrollToMenuItem(menuItem.mi_id)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("a", {
                    staticClass:
                      "item_button--container item_button--container-select material-icons",
                    class: {
                      "item_button--container-active":
                        -1 !==
                        _vm.$store.state.selectedMenuItemIds.indexOf(
                          menuItem.mi_id
                        ),
                    },
                    attrs: {
                      href: "#",
                      title:
                        -1 !==
                        _vm.$store.state.selectedMenuItemIds.indexOf(
                          menuItem.mi_id
                        )
                          ? "Click to remove this item from saved list"
                          : "Click to save this item for later",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        $event.stopPropagation()
                        return _vm.$store.commit("toggleMenuItemSelected", [
                          menuItem.mi_id,
                          _vm.menu?.menu_id || 0,
                        ])
                      },
                    },
                  }),
                ])
              }),
              _vm._v(" "),
              !_vm.$store.state.selectedMenuItemIds.length
                ? _c("li", [
                    _c("div", { staticClass: "favorites--content" }, [
                      _c("i", [_vm._v("No Favorites Selected.")]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          Click the "),
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("favorite_border"),
                      ]),
                      _vm._v(
                        " next to a menu item you want to store as a\n          favorite.\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c("loader", {
        ref: "loader",
        attrs: { active: _vm.isLoading },
        nativeOn: {
          click: function ($event) {
            _vm.isLoading = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }